module.exports = __webpack_public_path__ + "img/icon-question-description.506b2751.svg";